rs.module("controls/framework/ag/agValueFormatting",

    [],

    function () {

        //
        // Get the formatter by the given name
        //
        function format(value, options, params) {

            var name = options.name;

            // Validate the formatter name
            if (name && !formatters[name]) {
                throw new Error(`No such custom ag value formatter by the name of '${name}'.`);
            }

            // If value is null, use our null display text if there is any
            if (value == null && options.nullText != null) {
                return options.nullText;
            }

            // Determine if this is numeric.  If there is a column involved (grid), it tells us.  If not (chart), we can
            // try to figure it out.
            var isNumeric = params.column ?
                params.column.colDef.context["_lrs/isNumeric"] :
                name == "numeric" || name == "decimal" || name == "currency" || name == "duration" || name == "percent";

            // Special case for numerics
            if (isNumeric) {

                // The empty string means null
                if (value === "") {
                    value = null;
                }

                // If its null, but its nullable, format it as the empty string
                if (value == null && params.column.colDef.context["_lrs/isNullable"]) {
                    return "";
                }

                // Attempt to convert to a number (the 'weirdness' of this converts null, true, and false to numbers... we don't want to accidentally treat
                // those as numbers)
                if (value != null && typeof variable != "boolean") {
                    value = Number(value);
                }

                // If it isn't a valid numeric value, return the validation error
                if (typeof value !== "number" || isNaN(value)) {
                    return validationError("The entered value is not a number.", params);
                }
            }

            // If value is still null, return the null
            if (value == null) {
                return null;
            }

            // Name could be null if formatting was only applied in order to set null display text
            if (!name) {
                return value;
            }

            // Add the value to the params, the validationError function uses.  params could be null within unit test
            params = params || {};
            params.value = value;

            // Let the formatter do the formatting using the params from ag, and the options configured in razor
            return formatters[name](value, options, params);
        }

        var formatters = {

            //
            // Numeric formatter
            //
            numeric: function (value, options) {

                return $.format.number(value, options.format);
            },

            //
            // Date formatter
            //
            date: function (value, options) {

                // "M/d/yyyy" matches ToShortDateString(), which the is what our DefaultValueFormatter uses, and we use here
                // to match the case where no specific other formatting was supplied.
                var format = options.format || "M/d/yyyy";

                // if empty string is formatted, it returns 0
                return value == '' ? '' : $.format.date(value, format);
            },

            //
            // Currency formatter
            //
            currency: function (value, options, params) {

                const tolerance = 0.000001;
                var isNegative = (value < 0) && (Math.abs(value) > tolerance);

                value = Math.abs(value);

                var dollars = Math.floor(value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                var cents = value - Math.floor(value);

                var formattedCurrency = "$" + dollars + "." + cents.toFixed(2).toString().substring(2);

                return isNegative ? `(${formattedCurrency})` : formattedCurrency;
            },

            //
            // Decimal formatter
            //
            decimal: function (value, options) {
                // display up to a given number of significant figures
                if (options.FormatParameters){
                    var scale = options.FormatParameters.Scale ? options.FormatParameters.Scale : 0;

                    value = $.format.number(value, "#,##0." + ('#').repeat(scale));
                }

                return value;
            },

            //
            // Duration formatter as hours:minutes:seconds.milliseconds
            //
            duration: function (value) {

                var milliseconds = value;
                var seconds = 0;
                var minutes = 0;
                var hours = 0;
                
                if (milliseconds > 1000) {
                    seconds = Math.floor(milliseconds / 1000);
                    milliseconds %= 1000;
                }
                if (seconds > 60) {
                    minutes = Math.floor(seconds / 60);
                    seconds %= 60;
                }
                if (minutes > 60) {
                    hours = Math.floor(minutes / 60);
                    minutes %= 60;
                }
                
                return hours.toFixed(0).padStart(2, "0") + ":" +
                    minutes.toFixed(0).padStart(2, "0") + ":" +
                    seconds.toFixed(0).padStart(2, "0") + "." +
                    milliseconds.toFixed(0).padStart(3, "0");
            },

            //
            // Email formatter - just echo the value back.  This ValueFormat exists in C# to validate email's being entered,
            // not to format them going out for display.
            //
            email: function (value) {
                return value;
            },

            //
            // Percent formatter
            //
            percent: function (value, options, params) {

                value = value * 100;

                if (options.FormatParameters){
                    var scale = options.FormatParameters.Scale ? options.FormatParameters.Scale : 0;

                    value = $.format.number(value, "#,##0." + ('#').repeat(scale));
                }

                return value + "%";
            },

            //
            // Zipcode formatter
            //
            zip: function (zip) {

                // keep orginal value; if zip cannot be formatted, return exactly what was sent in
                var original = zip;

                // Strip any previous formatting
                zip = zip.replace(/-/g, "").replace(/ /g, "");

                var allDigits = !isNaN(zip);

                // US 5-digit (all numeric)
                if (zip.length === 5 && allDigits) {
                    return zip;
                }

                // US zip (all numeric)
                if (zip.length > 5 && zip.length <= 9 && allDigits) {
                    return zip.insert(5, "-");
                }

                // UK zip (always between 5 and 7 chars, and the last two are always letters)
                if (zip.length >= 5 && zip.length <= 7) {

                    var lastChar = zip.charAt(zip.length - 1);
                    var penultimateChar = zip.charAt(zip.length - 2);

                    if (lastChar.match("[a-zA-Z]") && penultimateChar.match("[a-zA-Z]")) {
                        return zip.insert(zip.length - 3, " ");
                    }
                }

                //Canada, always 6, always letter, digit, repeat.
                if (zip.length === 6) {
                    
                    var isCanadian;

                    [...zip].forEach((c, index) => isCanadian = index % 2 == 0 ? c.match("[a-zA-Z]") : !isNaN(c));

                    if (isCanadian) {
                        return zip.insert(3, " ");
                    }
                }

                return original;
            }
        };

        //
        // Generate a validation error with the specified message in the cell represented by params.
        //
        function validationError(message, params) {

            // Add the validation error to the row data for the node.  We have to check if validation has been setup yet, it's possible to get
            // here too early in the ag-grid life cycle
            if (params.node.data.__validation) {
                params.node.data.__validation[params.column.colDef.context["_lrs/property"]] = message;
            }

            // Return back the value as entered by the user, this is what will be displayed in the cell (exactly what they typed)
            return params.value;
        }

        // Exported public API
        var exports = {
            format
        };

        return exports;
    }
);